import { TypedDocumentNode } from '@apollo/client';
import { useMutation, useQuery } from '@apollo/client/react';
import {
  Mutation,
  MutationRegisterAzureTenantArgs,
  Query,
  RegisterAzureTenantInput
} from 'graphql/generated/graphqlTypes';
import { REGISTER_AZURE_TENANT } from 'graphql/mutations';
import { GET_TENANT_REGISTRATION_INFO } from 'graphql/queries';
import { BaseHookProps } from 'hooks/shared/types';
import { useEffect } from 'react';

// Typing the documents (instead of passing generics to the Apollo hooks) avoids the deprecated hook signatures.
const GET_TENANT_REGISTRATION_INFO_TYPED: TypedDocumentNode<Pick<Query, 'getTenantRegistrationInfo'>> =
  GET_TENANT_REGISTRATION_INFO;
const REGISTER_AZURE_TENANT_TYPED: TypedDocumentNode<
  Pick<Mutation, 'registerAzureTenant'>,
  MutationRegisterAzureTenantArgs
> = REGISTER_AZURE_TENANT;

const useTenantRegistrationInfo = ({ handleFetchError }: BaseHookProps) => {
  const {
    loading: tenantRegistrationInfoLoading,
    data,
    error: tenantRegistrationInfoError
  } = useQuery(GET_TENANT_REGISTRATION_INFO_TYPED);

  useEffect(() => {
    if (tenantRegistrationInfoError) handleFetchError('Error while fetching tenant registration info');
  }, [tenantRegistrationInfoError]);

  const [registerAzureTenantMutation, { loading: registerAzureTenantLoading }] =
    useMutation(REGISTER_AZURE_TENANT_TYPED);

  const registerAzureTenant = async (input: RegisterAzureTenantInput) => {
    const result = await registerAzureTenantMutation({
      variables: {
        input
      }
    });
    return result;
  };

  return {
    tenantRegistrationInfo: data?.getTenantRegistrationInfo,
    tenantRegistrationInfoLoading,
    registerAzureTenant,
    registerAzureTenantLoading
  };
};

export default useTenantRegistrationInfo;
